module.exports = {"firstName":null,"lastName":null,"email":null,"phone":null,"role":null,"relationship":null,"otherRelationship":null,"agreesToNotifyPoc":null}


//////////////////
// WEBPACK FOOTER
// ./src/components/settings/tabs/team_members/resources/poc_model.json
// module id = D9f/
// module chunks = 1